module.exports = __webpack_public_path__ + "static/media/Angie Brooke Headshot.6607e84d.jpeg";